import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { StepStatus } from '../../shared/models/models';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-step-card',
    templateUrl: './step-card.component.html',
    styleUrl: './step-card.component.scss',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [NgClass, TranslatePipe],
})
export class StepCardComponent {
  stepNumber = input<number>();
  stepName = input<string>();
  status = input<StepStatus>();
  special = input<boolean>(false);
  isLastOfPhase = input<boolean>(false);
  isLastAbsoluteStep = input<boolean>(false);
  isDisabled = input<boolean>(false);

  stepClick = output<number>();

  readonly stepStatus = StepStatus;

  get cardClasses() {
    return {
      'card--active': this.status() === StepStatus.Active,
      'card--completed': this.status() === StepStatus.Completed,
      'card--special': this.special(),
      'card--disabled': this.isDisabled(),
    };
  }

  get connectorLineClasses() {
    return {
      'connector__line--active': this.status() === StepStatus.Active,
      'connector__line--completed': this.status() === StepStatus.Completed,
      'connector__line--inactive': this.status() === StepStatus.Inactive,
      'connector__line--special': this.special(),
      'connector__line--last-step': this.isLastOfPhase(),
    };
  }

  get connectorDotClasses() {
    return {
      'connector__dot--active': this.status() === StepStatus.Active,
      'connector__dot--completed': this.status() === StepStatus.Completed,
      'connector__dot--inactive': this.status() === StepStatus.Inactive,
      'connector__dot--special': this.special(),
    };
  }

  onStepClick(): void {
    const stepNum = this.stepNumber();
    if (stepNum !== undefined) {
      this.stepClick.emit(stepNum);
    }
  }
}
